class FilterByExpertType {
  static filter(value, scope) {
    const currentFilterValue = scope.$ctrl.currentSelectedExpertType;
    if (value && currentFilterValue !== '') {
      const filtered = value.filter(val => val.expertType === currentFilterValue || val.expertType === 'TBC');
      return filtered;
    }
    return value;
  }
}

export default FilterByExpertType.filter;



// WEBPACK FOOTER //
// ./src/filters/expert-type.filter.js